import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DATEPICKER_DATE_FORMAT } from '@app/app.constants';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import { PregnancyType } from '@app/modules/service-data/types/service-data.types';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationErrorComponent } from '@shared/components/validation-error/validation-error.component';
import { InputValidationStatusDirective } from '@shared/directives/input-validation-status.directive';
import { RequirePermissionDirective } from '@shared/directives/require-permission.directive';
import { controlContainerProvider } from '@shared/helpers';
import moment from 'moment';
import {
  RadioFormType,
  ServiceDataFormConditionHistoryComponent,
} from '../service-data-form-condition-history/service-data-form-condition-history.component';
import { ServiceDataFormGestationAgeComponent } from './service-data-form-gestation-age/service-data-form-gestation-age.component';
import { ServiceDataFormInVitroComponent } from './service-data-form-in-vitro/service-data-form-in-vitro.component';
import { ServiceDataFormPregnancyTypeComponent } from './service-data-form-pregnancy-type/service-data-form-pregnancy-type.component';
import { ServiceDataFormPriorScreeningTestComponent } from './service-data-form-prior-screening-test/service-data-form-prior-screening-test.component';
import { ServiceDataFormVanishingTwinSyndromeComponent } from './service-data-form-vanishing-twin-syndrome/service-data-form-vanishing-twin-syndrome.component';

@Component({
  selector: 'app-service-data-form-current-pregnancy-information',
  imports: [
    ReactiveFormsModule,
    TranslateModule,
    TranslateModule,
    ValidationErrorComponent,
    NgbDatepickerModule,
    InputValidationStatusDirective,
    ServiceDataFormPriorScreeningTestComponent,
    ServiceDataFormConditionHistoryComponent,
    ServiceDataFormVanishingTwinSyndromeComponent,
    ServiceDataFormInVitroComponent,
    ServiceDataFormPregnancyTypeComponent,
    ServiceDataFormGestationAgeComponent,
    RequirePermissionDirective,
  ],
  templateUrl:
    './service-data-form-current-pregnancy-information.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormCurrentPregnancyInformationComponent {
  @Input() fieldSet: string[] = [];
  @Input() id: string;
  protected readonly PregnancyType = PregnancyType;
  protected readonly Object = Object;

  protected minDate = moment().subtract(1, 'year');
  protected maxDate = moment().add(1, 'year');
  protected DATEPICKER_DATE_FORMAT = DATEPICKER_DATE_FORMAT;

  protected readonly RadioFormType = RadioFormType;
  protected readonly ServiceDataFields = ServiceDataFields;
}
